import { INode } from 'shared/types/tree'
import { parseHtmlString } from 'shared/utils'
import { contentFromNode } from './utility'
import { nodesOfTypeWithContent } from '../../utility/TreeHelpers'

function getAffectedElements(doc: Document) {
  return Array.from(doc.getElementsByTagName('img')).filter((element) => {
    return !!element.getAttribute('onerror')
  })
}

function getAffectedNodes(node: INode) {
  const doc = parseHtmlString(contentFromNode(node))
  return getAffectedElements(doc)
}

function findAffectedNodes(tree: INode) {
  const types: string[] = []
  const content = ['onerror']
  const extraCheck = (node: INode) => !!getAffectedNodes(node).length
  return nodesOfTypeWithContent({
    tree,
    content,
    types,
    extraCheck,
  })
}

function convertContent(html: string) {
  const asDoc = parseHtmlString(html)
  getAffectedElements(asDoc).forEach((img) => {
    img.removeAttribute('onerror')
  })
  return asDoc.body.innerHTML
}

export default { findAffectedNodes, convertContent }
